import { translations } from "../../translations"
import styles from "./AboutMeWindow.module.css"

export default function EducationSection() {
    return (
        <section className={styles.section}>
            <div className={styles.sectionTitleRow}>
                <img src="/images/icons/graduation.svg" className={styles.sectionIconImg} alt="" />
                <h2 className={styles.sectionTitle}>{translations('about_me.education')}</h2>
            </div>
            <div className={styles.eduItem}>
                <div className={styles.eduBar} />
                <div>
                    <div className={styles.eduTitle}>{translations('about_me.education_degree')}</div>
                    <div className={styles.eduSub}>{translations('about_me.education_year')}</div>
                </div>
            </div>
        </section>
    )
}
